document.addEventListener('DOMContentLoaded', function () {
  function updateTimers() {
    document.querySelectorAll('.custom-card-timer').forEach(function (el) {
      var endSeconds = parseInt(el.getAttribute('data-end'));
      var endMs = endSeconds * 1000;
      var now = Date.now();
      var diff = endMs - now;

      if (diff <= 0) {
        el.style.display = 'none';
        return;
      }

      var days  = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins  = Math.floor((diff % 3600000) / 60000);
      var secs  = Math.floor((diff % 60000) / 1000);

      el.querySelector('.timer-days').textContent  = String(days).padStart(2, '0');
      el.querySelector('.timer-hours').textContent = String(hours).padStart(2, '0');
      el.querySelector('.timer-mins').textContent  = String(mins).padStart(2, '0');
      el.querySelector('.timer-secs').textContent  = String(secs).padStart(2, '0');
    });
  }

  updateTimers();
  setInterval(updateTimers, 1000);
});
